import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Signup from './pages/Signup';
import LandingHeader from './Components/LandingHeader';
import Footer from './Components/Footer';
import StudentHeader from './Components/StudentHeader';
import TrainerHeader from './Components/TrainerHeader';
import ConsultantHeader from './Components/ConsultantHeader';
import ConditionalTrainerHeader from './Components/ConditionalTrainerHeader';
import HomeStud from './pages/student/HomeStud';
import MyClasses from './pages/student/MyClasses';
import StudentSettings from './pages/student/StudentSettings';
import MyPlans from './pages/student/MyPlans';
import MyTrainer from './pages/student/MyTrainer';
import StudentProfile from './pages/student/StudentProfile';
import MemberMarket from './pages/student/MemberMarket';
import MyAppointments from './pages/student/MyAppointments';
import HomeTrainer from './pages/trainer/HomeTrainer';
import Classes from './pages/trainer/Classes';
import Programs from './pages/trainer/Programs';
import ConsultantPrograms from './pages/trainer/ConsultantPrograms';
import FeesDetails from './pages/trainer/FeesDetails';
import MyStudents from './pages/trainer/MyStudents';
import FeePlan from './pages/trainer/FeePlan';
import Appointments from './pages/trainer/Appointments';
import ConsultantDashboard from './pages/trainer/ConsultantDashboard';
import TrainerSettings from './pages/trainer/TrainerSettings';
import TrainerProfile from './pages/trainer/TrainerProfile';
import PaymentPlanWizard from './pages/trainer/PaymentPlanWizard';
import Notifications from './pages/trainer/Notifications';
import AdminHeader from './Components/AdminHeader';
import AdminDashboard from './pages/admin/AdminDashboard';
import PendingApprovals from './pages/admin/PendingApprovals';
import SpecializationRequests from './pages/admin/SpecializationRequests';
import AllTrainers from './pages/admin/AllTrainers';
import AllUsers from './pages/admin/AllUsers';
import AllStudents from './pages/admin/AllStudents';
import AllPrograms from './pages/admin/AllPrograms';
import AllClasses from './pages/admin/AllClasses';
import Market from './pages/Market';
import Checkout from './pages/Checkout';
import OrderTracking from './pages/OrderTracking';
import ResellerApplication from './pages/ResellerApplication';
import ResellerDashboard from './pages/reseller/ResellerDashboard';
import ResellerProducts from './pages/reseller/ResellerProducts';
import ResellerOrders from './pages/reseller/ResellerOrders';
import ResellerEarnings from './pages/reseller/ResellerEarnings';
import MarketplaceDashboard from './pages/admin/MarketplaceDashboard';
import ResellerApprovals from './pages/admin/ResellerApprovals';
import ProductApprovals from './pages/admin/ProductApprovals';
import CommissionReport from './pages/admin/CommissionReport';
import About from './pages/About';
import ContactForm from './Components/ContactForm';
import Services from './pages/Services';
import PublicTrainerProfile from './pages/PublicTrainerProfile';
import LoginHeader from './Components/LoginHeader';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import { ToastContainer } from 'react-toastify';
import UserContext from './Components/UserContext';
import { useState, useEffect } from 'react';
import Guard from './Components/Guard';
import NotFound from './pages/NotFound';
import PWAInstallPrompt from './Components/PWAInstallPrompt';
import PWAUpdatePrompt from './Components/PWAUpdatePrompt';
import HomeRedirect from './Components/HomeRedirect';
import ServiceRouteGuard from './Components/ServiceRouteGuard';
import ChatBot from './Components/ChatBot';
import TrainerChatBot from './Components/TrainerChatBot';
import StudentChatBot from './Components/StudentChatBot';
import SplashScreen from './Components/SplashScreen';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import LegalDocuments from './pages/admin/LegalDocuments';
import NewsletterManagement from './pages/admin/NewsletterManagement';
import NotificationManagement from './pages/admin/NotificationManagement';
import AdminLayout from './Components/AdminLayout';
import Unsubscribe from './pages/Unsubscribe';
import HelpCenter from './pages/HelpCenter';
import ProductDetail from './pages/ProductDetail';
import AiChatInterface from './Components/AiChatInterface';
import MyAiConsultants from './pages/student/MyAiConsultants';

function App() {

  const [session, setSession] = useState(null)

  // Handle OAuth redirects and query params with sanitization
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const errorParam = urlParams.get('error');
    const messageParam = urlParams.get('message');

    // Sanitize error parameter
    if (errorParam) {
      const sanitizedError = errorParam.replace(/[^a-zA-Z0-9\-_]/g, '');
      if (sanitizedError === 'oauth_failed' && sanitizedError === errorParam) {
        // Toast will be shown by Login component
      }
    }

    // Sanitize message parameter
    if (messageParam) {
      const sanitizedMessage = messageParam.replace(/[^a-zA-Z0-9\-_]/g, '');
      if (sanitizedMessage === 'pending_approval' && sanitizedMessage === messageParam) {
        // Toast will be shown by Login component
      }
    }
  }, []);

  return (
    <UserContext.Provider value={{ session, setSession }}>
      <SplashScreen />
      <BrowserRouter>
        {/* Skip to main content link for accessibility */}
        <a
          href="#main-content"
          className="sr-only focus:not-sr-only focus:absolute focus:top-0 focus:left-0 focus:z-50 focus:p-4 focus:bg-blue-600 focus:text-white focus:underline"
        >
          Skip to main content
        </a>
        <Routes>
          <Route
            path="/"
            element={<HomeRedirect />}
          />
          <Route
            path="/landing"
            element={
              <>
                <LandingHeader />
                <main className="flex-grow"><Landing /></main>
                <Footer />
              </>
            }
          />
          <Route
            path="/login"
            element={
              <>
                <LoginHeader />
                <main className="flex-grow"><Login /></main>
                <Footer />
              </>
            }
          />
          <Route
            path="/signup"
            element={
              <>
                <LoginHeader />
                <main className="flex-grow"><Signup /></main>
                <Footer />
              </>
            }
          />
          <Route
            path="/forgot-password"
            element={<ForgotPassword />}
          />
          <Route
            path="/reset-password"
            element={<ResetPassword />}
          />
          <Route element={<Guard />}>
            <Route path="/student/home" element={<><StudentHeader /><main className="flex-grow"><HomeStud /></main><Footer /></>} />
            <Route path="/student/myclasses" element={<><StudentHeader /><main className="flex-grow"><MyClasses /></main><Footer /></>} />
            <Route path="/student/plans" element={<><StudentHeader /><main className="flex-grow"><MyPlans /></main><Footer /></>} />
            <Route path="/student/trainer" element={<><StudentHeader /><main className="flex-grow"><MyTrainer /></main><Footer /></>} />
            <Route path="/student/appointments" element={<><StudentHeader /><main className="flex-grow"><MyAppointments /></main><Footer /></>} />
            <Route path="/student/profile" element={<><StudentHeader /><main className="flex-grow"><StudentProfile /></main><Footer /></>} />
            <Route path="/student/settings" element={<><StudentHeader /><main className="flex-grow"><StudentSettings /></main><Footer /></>} />
            <Route path="/student/market" element={<><StudentHeader /><main className="flex-grow"><Market /></main><Footer /></>} />
            <Route path="/student/help" element={<><StudentHeader /><main className="flex-grow"><HelpCenter /></main><Footer /></>} />
            <Route path="/student/reseller-application" element={<><StudentHeader /><main className="flex-grow"><ResellerApplication /></main><Footer /></>} />
            <Route path="/reseller/dashboard" element={<><StudentHeader /><main className="flex-grow"><ResellerDashboard /></main><Footer /></>} />
            <Route path="/reseller/products" element={<><StudentHeader /><main className="flex-grow"><ResellerProducts /></main><Footer /></>} />
            <Route path="/reseller/orders" element={<><StudentHeader /><main className="flex-grow"><ResellerOrders /></main><Footer /></>} />
            <Route path="/reseller/earnings" element={<><StudentHeader /><main className="flex-grow"><ResellerEarnings /></main><Footer /></>} />
            <Route path="/student/ai-chat/:sessionId" element={<><StudentHeader /><main className="flex-grow"><AiChatInterface /></main><Footer /></>} />
            <Route path="/student/my-ai" element={<><StudentHeader /><main className="flex-grow"><MyAiConsultants /></main><Footer /></>} />
            <Route path="/trainer/home" element={<><TrainerHeader /><main className="flex-grow"><HomeTrainer /></main><Footer /></>} />
            <Route path="/trainer/classes" element={
              <><TrainerHeader />
                <main className="flex-grow">
                  <ServiceRouteGuard allowedType="instructor" redirectTo="/trainer/appointments">
                    <Classes />
                  </ServiceRouteGuard>
                </main>
                <Footer />
              </>
            } />
            <Route path="/trainer/appointments" element={
              <><ConsultantHeader />
                <main className="flex-grow">
                  <ServiceRouteGuard allowedType="consultant" redirectTo="/trainer/classes">
                    <Appointments />
                  </ServiceRouteGuard>
                </main>
                <Footer />
              </>
            } />
            <Route path="/trainer/consultant-dashboard" element={
              <><ConsultantHeader />
                <main className="flex-grow">
                  <ServiceRouteGuard allowedType="consultant" redirectTo="/trainer/classes">
                    <ConsultantDashboard />
                  </ServiceRouteGuard>
                </main>
                <Footer />
              </>
            } />
            <Route path="/trainer/programs" element={
              <><ConditionalTrainerHeader />
                <main className="flex-grow">
                  <ServiceRouteGuard allowedType="instructor" redirectTo="/trainer/consultant-programs">
                    <Programs />
                  </ServiceRouteGuard>
                </main>
                <Footer />
              </>
            } />
            <Route path="/trainer/consultant-programs" element={
              <><ConsultantHeader />
                <main className="flex-grow">
                  <ServiceRouteGuard allowedType="consultant" redirectTo="/trainer/programs">
                    <ConsultantPrograms />
                  </ServiceRouteGuard>
                </main>
                <Footer />
              </>
            } />
            <Route path="/trainer/fees" element={<><ConditionalTrainerHeader /><main className="flex-grow"><FeesDetails /></main><Footer /></>} />
            <Route path="/trainer/students" element={<><ConditionalTrainerHeader /><main className="flex-grow"><MyStudents /></main><Footer /></>} />
            <Route path="/trainer/fee-plan" element={<><ConditionalTrainerHeader /><main className="flex-grow"><FeePlan /></main><Footer /></>} />
            <Route path="/trainer/trainer-profile" element={<><ConditionalTrainerHeader /><main className="flex-grow"><TrainerProfile /></main><Footer /></>} />
            <Route path="/trainer/settings" element={<><ConditionalTrainerHeader /><main className="flex-grow"><TrainerSettings /></main><Footer /></>} />
            <Route path="/trainer/notifications" element={<><ConditionalTrainerHeader /><main className="flex-grow"><Notifications /></main><Footer /></>} />
            <Route path="/trainer/payment-plan-wizard" element={<><TrainerHeader /><main className="flex-grow"><PaymentPlanWizard /></main><Footer /></>} />
            <Route path="/admin/dashboard" element={<AdminLayout><AdminDashboard /></AdminLayout>} />
            <Route path="/admin/pending-approvals" element={<AdminLayout><PendingApprovals /></AdminLayout>} />
            <Route path="/admin/specialization-requests" element={<AdminLayout><SpecializationRequests /></AdminLayout>} />
            <Route path="/admin/trainers" element={<AdminLayout><AllTrainers /></AdminLayout>} />
            <Route path="/admin/users" element={<AdminLayout><AllUsers /></AdminLayout>} />
            <Route path="/admin/students" element={<AdminLayout><AllStudents /></AdminLayout>} />
            <Route path="/admin/programs" element={<AdminLayout><AllPrograms /></AdminLayout>} />
            <Route path="/admin/classes" element={<AdminLayout><AllClasses /></AdminLayout>} />
            <Route path="/admin/legal-documents" element={<AdminLayout><LegalDocuments /></AdminLayout>} />
            <Route path="/admin/newsletter" element={<AdminLayout><NewsletterManagement /></AdminLayout>} />
            <Route path="/admin/notifications" element={<AdminLayout><NotificationManagement /></AdminLayout>} />
            <Route path="/admin/marketplace" element={<AdminLayout><MarketplaceDashboard /></AdminLayout>} />
            <Route path="/admin/marketplace/commission-report" element={<AdminLayout><CommissionReport /></AdminLayout>} />
            <Route path="/admin/reseller-approvals" element={<AdminLayout><ResellerApprovals /></AdminLayout>} />
            <Route path="/admin/product-approvals" element={<AdminLayout><ProductApprovals /></AdminLayout>} />
          </Route>


          <Route path="/Market" element={<><LandingHeader /><main className="flex-grow"><Market /></main><Footer /></>} />
          <Route path="/market" element={<><LandingHeader /><main className="flex-grow"><Market /></main><Footer /></>} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/checkout" element={<><LandingHeader /><main className="flex-grow"><Checkout /></main><Footer /></>} />
          <Route path="/student/checkout" element={<><StudentHeader /><main className="flex-grow"><Checkout /></main><Footer /></>} />
          <Route path="/orders" element={<><LandingHeader /><main className="flex-grow"><OrderTracking /></main><Footer /></>} />
          <Route path="/student/orders" element={<><StudentHeader /><main className="flex-grow"><OrderTracking /></main><Footer /></>} />
          <Route path="/reseller-application" element={<><LandingHeader /><main className="flex-grow"><ResellerApplication /></main><Footer /></>} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/help" element={<><LandingHeader /><main className="flex-grow"><HelpCenter /></main><Footer /></>} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          <Route path="/about" element={<><LandingHeader /><main className="flex-grow"><About /></main><Footer /></>} />
          <Route path="/student/about" element={<><StudentHeader /><main className="flex-grow"><About /></main><Footer /></>} />
          <Route path="/contact-form" element={<ContactForm />} />
          <Route path="/services" element={<><LandingHeader /><main className="flex-grow"><Services /></main><Footer /></>} />
          <Route path="/services/:serviceName" element={<><LandingHeader /><main className="flex-grow"><Services /></main><Footer /></>} />
          <Route path="/student/services" element={<><StudentHeader /><main className="flex-grow"><Services /></main><Footer /></>} />
          <Route path="/student/services/:serviceName" element={<><StudentHeader /><main className="flex-grow"><Services /></main><Footer /></>} />
          <Route path="/student/trainer/:trainerId" element={<><StudentHeader /><main className="flex-grow"><PublicTrainerProfile /></main><Footer /></>} />
          <Route path="/trainer/:trainerId" element={<PublicTrainerProfile />} />
          <Route path="*" element={<NotFound />}></Route>
        </Routes>
        <ToastContainer
          position="top-center"
          autoClose={3000}
          style={{ zIndex: 10000 }}
          className="toast-container"
        />

        {/* PWA Components */}
        <PWAInstallPrompt />
        <PWAUpdatePrompt />

        {/* ChatBot - Friendly Support Assistant (for public/landing page) */}
        <ChatBot />

        {/* StudentChatBot - Learning Assistant (for logged-in students/members) */}
        <StudentChatBot />

        {/* TrainerChatBot - Professional Assistant (for logged-in trainers) */}
        <TrainerChatBot />
      </BrowserRouter>
    </UserContext.Provider>
  );
}

export default App;